{
  "Save": "Guardar",
  "Saved": "Guardado",
  "Saving...": "A guardar...",
  "Saving…": "A guardar…",
  "Delete": "Eliminar",
  "Next": "Seguinte",
  "Skip": "Saltar",
  "Something went wrong": "Algo correu mal",
  "Something went wrong. Please try again.": "Algo correu mal. Tente novamente.",
  "Loading...": "A carregar...",
  "Loading…": "A carregar…",
  "Share": "Partilhar",
  "Settings": "Definições",
  "Open Settings": "Abrir definições",
  "Password": "Palavra-passe",
  "Logo": "Logótipo",
  "Fundraising": "Angariação de fundos",
  "My Events": "Os meus eventos",
  "Go Live": "Transmitir em direto",
  "Watch Live": "Ver em direto",
  "Live only": "Só em direto",
  "Sell Tickets": "Vender bilhetes",
  "Manage Video": "Gerir vídeo",
  "Upload video": "Carregar vídeo",
  "Camera": "Câmara",
  "Not signed in": "Não tem sessão iniciada",
  "Please sign in again.": "Inicie sessão novamente.",
  "Too many requests. Please wait a moment and try again.": "Demasiados pedidos. Aguarde um momento e tente novamente."
}
